import { makeStyles } from "tss-react/mui";

export const useNumberedPaginationStyles = makeStyles()((theme) => ({
  root: {
    marginTop: 16,
    marginBottom: 32,
    width: "100%",
    "& .MuiPagination-ul": {
      justifyContent: "center",
    },
    "& .MuiPaginationItem-root": {
      borderColor: theme.design.color.surface.subtle,
      color: theme.design.color.text.secondary,
      [theme.breakpoints.down("sm")]: {
        minWidth: 20,
        padding: 0,
      },
    },
    "& .MuiPaginationItem-page.Mui-selected": {
      backgroundColor: theme.design.color.surface.subtle,
      color: theme.design.color.text.primary,
    },
    "& .MuiButtonBase-root": {
      [theme.breakpoints.down("sm")]: {
        minWidth: 25,
        width: 25,
        height: 25,
        fontSize: 12,
      },
    },
  },
}));

export const useRangePaginationStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    gap: 8,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      marginTop: 8,
      gap: 8,
    },
  },
  centered: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
  },
  divider: {
    marginTop: 16,
    paddingTop: 16,
    paddingBottom: 16,
    borderTop: `1px solid ${theme.design.color.border.popover}`,
  },
  summary: {
    color: theme.design.color.text.primary,
    fontSize: 14,
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    },
  },
  mutedSummary: {
    color: theme.design.color.text.muted,
    fontSize: 12,
    minHeight: 18,
    lineHeight: "18px",
    textAlign: "center",
  },
  controls: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    [theme.breakpoints.down("sm")]: {
      gap: 4,
    },
  },
  button: {
    color: theme.design.color.text.primary,
    padding: 8,
    minWidth: 32,
    height: 32,
    borderRadius: theme.design.radius.sm,
    "&:hover": {
      backgroundColor: theme.design.color.surface.subtleHover,
    },
    "&:disabled": {
      color: theme.design.color.action.disabled,
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: 28,
      height: 28,
      padding: 6,
    },
  },
  buttonActive: {
    backgroundColor: theme.design.color.action.secondaryHover,
    color: theme.design.color.text.primary,
    "&:hover": {
      backgroundColor: theme.design.color.action.secondary,
    },
  },
  pageLabel: {
    color: theme.design.color.text.primary,
    fontSize: 14,
    fontFamily: theme.design.typography.fontFamily,
    margin: "0 8px",
    userSelect: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    },
  },
  pageNumbers: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    [theme.breakpoints.down("sm")]: {
      gap: 2,
    },
  },
  pageNumber: {
    fontSize: 14,
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    },
  },
  ellipsis: {
    color: theme.design.color.text.muted,
    fontSize: 14,
    padding: "0 8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
      padding: "0 4px",
    },
  },
}));
